import { AbstractControl, ValidatorFn } from "@angular/forms";

//One Uppercase English letter
//One Lowercase English letter
//One Digit
//One Special Character (#?!@$%^&*-)
//Minimum eight characters
const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

export function passwordValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    return passwordRegex.test(control.value)
      ? null
      : {
          passwordNotValid:
            "Password does not meet criteria of at least one uppercase, one lowercase, one digit, one special character (#?!@$%^&*-), and at least 8 characters",
        };
  };
}

export function confirmPasswordValidator(
  passwordForm: AbstractControl,
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    return control.value === passwordForm.value
      ? null
      : { passwordNotMatching: "Confirm password does not match" };
  };
}
